// extracted by mini-css-extract-plugin
export default {"footerContainer":"style_footerContainer__myQ5l","copyrightNote":"style_copyrightNote__rG+SI"};